import { basePermissionManagerApi as api } from '../basePermissionManagerApi'
export const addTagTypes = ['Relationship'] as const
const injectedRtkApi = api
  .enhanceEndpoints({
    addTagTypes,
  })
  .injectEndpoints({
    endpoints: (build) => ({
      postRelationshipsQuery: build.mutation<
        PostRelationshipsQueryApiResponse,
        PostRelationshipsQueryApiArg
      >({
        query: (queryArg) => ({
          url: `/relationships/query`,
          method: "POST",
          body: queryArg.serviceAuthorisationDomainModelsFiltersAuthRelationshipFilter,
        }),
        invalidatesTags: ["Relationship"],
      }),
      postRelationships: build.mutation<
        PostRelationshipsApiResponse,
        PostRelationshipsApiArg
      >({
        query: (queryArg) => ({
          url: `/relationships`,
          method: "POST",
          body: queryArg.serviceAuthorisationDomainModelsSpiceDbRequestsSpiceDbWriteRelationshipsRequest,
        }),
        invalidatesTags: ["Relationship"],
      }),
      putRelationships: build.mutation<
        PutRelationshipsApiResponse,
        PutRelationshipsApiArg
      >({
        query: (queryArg) => ({
          url: `/relationships`,
          method: "PUT",
          body: queryArg.serviceAuthorisationDomainModelsSpiceDbRequestsSpiceDbUpdateRelationshipsRequest,
        }),
        invalidatesTags: ["Relationship"],
      }),
      deleteRelationships: build.mutation<
        DeleteRelationshipsApiResponse,
        DeleteRelationshipsApiArg
      >({
        query: (queryArg) => ({
          url: `/relationships`,
          method: "DELETE",
          body: queryArg.serviceAuthorisationDomainModelsSpiceDbRequestsSpiceDbWriteRelationshipsRequest,
        }),
        invalidatesTags: ["Relationship"],
      }),
    }),
    overrideExisting: false,
  })
export { injectedRtkApi as baseGeneratedApi }
export type PostRelationshipsQueryApiResponse =
  /** status 200 Returns SpiceDB relationships for the specified users, namespaces and resource types (when provided). */ ServiceAuthorisationDomainModelsAuthRelationship[]
export type PostRelationshipsQueryApiArg = {
  serviceAuthorisationDomainModelsFiltersAuthRelationshipFilter: ServiceAuthorisationDomainModelsFiltersAuthRelationshipFilter
}
export type PostRelationshipsApiResponse =
  /** status 200 Creates SpiceDB relationships in the specified namespace. Returns the SpiceDB ZedToken. */ AuthzedApiV1ZedToken
export type PostRelationshipsApiArg = {
  serviceAuthorisationDomainModelsSpiceDbRequestsSpiceDbWriteRelationshipsRequest: ServiceAuthorisationDomainModelsSpiceDbRequestsSpiceDbWriteRelationshipsRequest
}
export type PutRelationshipsApiResponse =
  /** status 200 Updates SpiceDB relationships in the specified namespace. Returns the SpiceDB ZedToken. */ AuthzedApiV1ZedToken
export type PutRelationshipsApiArg = {
  serviceAuthorisationDomainModelsSpiceDbRequestsSpiceDbUpdateRelationshipsRequest: ServiceAuthorisationDomainModelsSpiceDbRequestsSpiceDbUpdateRelationshipsRequest
}
export type DeleteRelationshipsApiResponse =
  /** status 200 Deletes SpiceDB relationships in the specified namespace. Returns the SpiceDB ZedToken. */ AuthzedApiV1ZedToken
export type DeleteRelationshipsApiArg = {
  serviceAuthorisationDomainModelsSpiceDbRequestsSpiceDbWriteRelationshipsRequest: ServiceAuthorisationDomainModelsSpiceDbRequestsSpiceDbWriteRelationshipsRequest
}
export type ServiceAuthorisationDomainModelsAuthRelationship = {
  relationshipId?: number
  namespace?: string | null
  resourceType: string | null
  resourceId: string | null
  relation: string | null
  subjectType: string | null
  subjectId: string | null
  subjectRelation?: string | null
  caveat?: string | null
  expiresAt?: string | null
  createdBy: string | null
  createdAt?: string
}
export type ServiceAuthorisationDomainModelsFiltersAuthRelationshipFilter = {
  subjectIds: string[] | null
  namespaces?: string[] | null
  resourceTypes?: string[] | null
}
export type AuthzedApiV1ZedToken = {
  token?: string | null
}
export type ServiceAuthorisationDomainModelsSpiceDbRequestsSpiceDbUserRelationshipRequest =
  {
    namespace: string | null
    resourceType: string | null
    resourceId: string | null
    relation: string | null
    userId: string | null
    expiresAt?: string | null
  }
export type ServiceAuthorisationDomainModelsSpiceDbRequestsSpiceDbWriteRelationshipsRequest =
  {
    relationships:
      | ServiceAuthorisationDomainModelsSpiceDbRequestsSpiceDbUserRelationshipRequest[]
      | null
  }
export type ServiceAuthorisationDomainModelsSpiceDbRequestsSpiceDbUpdateRelationshipsRequest =
  {
    relationshipsToDelete:
      | ServiceAuthorisationDomainModelsSpiceDbRequestsSpiceDbUserRelationshipRequest[]
      | null
    relationshipsToAdd:
      | ServiceAuthorisationDomainModelsSpiceDbRequestsSpiceDbUserRelationshipRequest[]
      | null
  }
export const {
  usePostRelationshipsQueryMutation,
  usePostRelationshipsMutation,
  usePutRelationshipsMutation,
  useDeleteRelationshipsMutation,
} = injectedRtkApi
